
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#006CB5","d":"M0 42h32V0H0z"}}),_c('path',{attrs:{"fill":"#FFFFFE","d":"M16.497 24.481c-1.471 0-2.664-1.228-2.664-2.742 0-1.515 1.193-2.743 2.664-2.743s2.664 1.228 2.664 2.743c0 1.514-1.193 2.742-2.664 2.742m.57-7.735c-3.758 0-5.308 2.826-5.308 4.993 0 2.693 2.121 4.877 4.738 4.877 2.616 0 4.738-2.184 4.738-4.877 0-.919-.247-1.777-.676-2.51 2.2.661 4.376 2.459 4.894 3.005-1.441 3.396-4.745 5.634-8.94 5.634-4.194 0-7.536-2.249-9.332-6.019 1.421-3.863 5.253-6.713 9.887-6.713 3.137 0 6.78 1.056 9.624 3.318.36-1.254.35-2.4.35-2.4S22.836 13 17.07 13C10.38 13 6.166 17.671 5 21.85A12.004 12.004 0 0016.499 30c6.06 0 10.127-4.061 11.501-8.15-2.608-2.979-6.642-5.104-10.932-5.104"}})])])
          )
        }
      }
    